import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from '@src/common/formatImage';
import { getThumbnail } from '@src/common/utils';

class TabContent extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    state = {
        currentIndex: 0
    }

    setCurrentIndex = (index) => {
        this.setState({
            currentIndex: index
        });
    }

    render() {
        const { content } = this.props;
        const { currentIndex } = this.state;

        return (
            <div className={styles.tabContent}>
                <div className={styles.left}>
                    {
                        content.map((item, index) => {
                            return (
                                <div className={styles.imageItem} key={index} onClick={() => this.setCurrentIndex(index)}>
                                    <img src={formatImage(getThumbnail(item), 242, 174)} alt="" />
                                    <div className={`${styles.title} ${currentIndex === index ? styles.active : ''}`}>
                                        <a href={item.url} target="_blank">
                                            {item.title}
                                        </a>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
                <div className={styles.right}>
                    {
                        content[currentIndex].children && content[currentIndex].children.map((item, index) => {
                            return (
                                <div className={styles.news} key={index}>
                                    <div className={styles.title}>
                                        <a href={item.url} target="_blank">
                                            {item.title}
                                        </a>
                                    </div>
                                    <div className={styles.content}>
                                        {item.summary}
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

export default TabContent;
